import { ChangeDetectionStrategy, Input, Component, Output, EventEmitter, ViewEncapsulation } from "@angular/core";
import { S25IconComponent } from "../modules/s25-icon/s25.icon.component";
import { TypeManagerDecorator } from "../main/type.map.service";
import { S25IconModule } from "../modules/s25-icon/s25.icon.module";
import { Bind } from "../decorators/bind.decorator";

@TypeManagerDecorator("s25-ng-icon-button")
@Component({
    selector: "s25-ng-icon-button",
    template: `
        <button (click)="clickHandler($event)" class="c-iconButton">
            <s25-ng-icon [type]="type" [label]="label" [size]="size" [autoDarkMode]="autoDarkMode"></s25-ng-icon>
        </button>
    `,
    styles: `
        .c-iconButton {
            background-color: unset;
            border: none;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    imports: [S25IconModule],
})
export class S25IconButtonComponent extends S25IconComponent {
    @Output() click = new EventEmitter<MouseEvent>();

    @Bind
    clickHandler(event: MouseEvent) {
        this.click.emit(event);
    }
}
